import {  FETCH_VER } from '../actions/types'


const verReducer = (state = 0, action) => {
 // console.log("ver",action.type,action.ver)
  switch (action.type) {
    case FETCH_VER:
      return action.ver



    default:
      return state
  }
}

export default verReducer